import { render, staticRenderFns } from "./MonitoramentoDescricao.vue?vue&type=template&id=e2e10306&scoped=true&"
import script from "./MonitoramentoDescricao.vue?vue&type=script&lang=js&"
export * from "./MonitoramentoDescricao.vue?vue&type=script&lang=js&"
import style0 from "./MonitoramentoDescricao.vue?vue&type=style&index=0&id=e2e10306&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e10306",
  null
  
)

export default component.exports